/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplicationParameter } from '../../models/application-parameter';

export interface GetApplicationParameter$Params {
  parameterCode: 'GAMIDA' | 'DEFAULT_HW_MAX_EXP_DAYS' | 'HW_TOTAL_MAX_EXP_MONTHS' | 'OMISIRGE';
}

export function getApplicationParameter(http: HttpClient, rootUrl: string, params: GetApplicationParameter$Params, context?: HttpContext): Observable<StrictHttpResponse<ApplicationParameter>> {
  const rb = new RequestBuilder(rootUrl, getApplicationParameter.PATH, 'get');
  if (params) {
    rb.path('parameterCode', params.parameterCode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApplicationParameter>;
    })
  );
}

getApplicationParameter.PATH = '/app-parameter/{parameterCode}';
